export default __webpack_public_path__ + "static/media/fridge1-after1-1440w.8c5a05eb.avif";